'use client';

import React, { useState } from 'react';

const faqs = [
  {
    id: 'faq-1',
    q: 'What is BioLink and how does it work?',
    a: 'BioLink lets you create a single shareable page with all your important links. You get a URL like biolink.app/yourname that you put in your Instagram bio. When someone visits your page, they see all your links in one beautiful place.',
  },
  {
    id: 'faq-2',
    q: 'Is BioLink really free to start?',
    a: 'Yes! Our Free plan lets you create one bio page with up to 5 links and basic analytics. You can upgrade to Pro or Business at any time to unlock unlimited links, premium templates, and advanced analytics.',
  },
  {
    id: 'faq-3',
    q: 'Can I use BioLink with Instagram?',
    a: 'Absolutely. BioLink is designed specifically for the Instagram bio link use case. Just copy your BioLink URL and paste it into your Instagram profile. Your followers will see all your links in one tap.',
  },
  {
    id: 'faq-4',
    q: 'Do I need coding skills to use BioLink?',
    a: 'Not at all. BioLink is designed for creators, not developers. You can set up your entire bio page in under 5 minutes — no code, no design skills needed.',
  },
  {
    id: 'faq-5',
    q: 'What analytics does BioLink provide?',
    a: 'On the Pro plan, you get 90 days of analytics including page views, unique visitors, link clicks, click-through rate, traffic sources, device types, and top-performing links. Business plan includes 1 year of data.',
  },
  {
    id: 'faq-6',
    q: 'Can I use my own domain name?',
    a: 'Custom domains are available on the Business plan. You can connect any domain you own, like links.yourbrand.com, and BioLink will serve your profile page from that URL.',
  },
];

export default function LandingFAQ() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  return (
    <section className="py-20 bg-card/50">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-700 text-primary uppercase tracking-widest mb-3">FAQ</span>
          <h2 className="text-4xl font-800 text-foreground mb-4">Frequently asked questions</h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs?.map((faq) => (
            <div
              key={faq?.id}
              className="bg-card rounded-xl border border-border overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenId(openId === faq?.id ? null : faq?.id)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-muted/50 transition-colors"
                aria-expanded={openId === faq?.id}
              >
                <span className="text-sm font-600 text-foreground pr-4">{faq?.q}</span>
                <svg
                  className={`w-5 h-5 text-muted-foreground flex-shrink-0 transition-transform duration-200 ${
                    openId === faq?.id ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {openId === faq?.id && (
                <div className="px-6 pb-5 animate-fade-in">
                  <p className="text-sm text-muted-foreground leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}